import { PortDistancesScreen, RouteScreen } from '@felix/ui';
import { useTranslation } from 'react-i18next';
import { Shell } from '../components/Shell.js';
import { officePortsSource } from '../ports-source.js';
import { officeVoyageSource } from '../voyage-source.js';

/** Voyage ▸ Route & Distances (ADR 0048 §6): güzergâh gemide planlanır; ofiste salt okunur. */
export function RoutePage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('ports.route.title')}>
      <RouteScreen source={officeVoyageSource} ports={officePortsSource} />
    </Shell>
  );
}

/** Voyage ▸ Port Distances (ADR 0048 §3): şirketin mesafe tablosu ve şirket limanları. */
export function PortDistancesPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('ports.distances.title')}>
      <PortDistancesScreen source={officePortsSource} />
    </Shell>
  );
}
